import { render, staticRenderFns } from "./VBarChart305.vue?vue&type=template&id=9836a81e&scoped=true"
import script from "./VBarChart305.vue?vue&type=script&lang=js"
export * from "./VBarChart305.vue?vue&type=script&lang=js"
import style0 from "./VBarChart305.vue?vue&type=style&index=0&id=9836a81e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9836a81e",
  null
  
)

export default component.exports